<template>
<section class="bg-purple-600 bg-gradient-to-b from-purple-500 to-purple-600 rounded-xl shadow-sm flex space-y-2 flex-col justify-center w-full">

<div v-if="isAsideExpanded" class="text-white hidden md:flex space-x-2 pl-3 text-2xl" >
  <div  class="w-8 table my-auto">
    <img class="h-full" src="/logo-white.png" alt="logo">
  </div>
  <h3>Talk Chat</h3>
</div>


<div class="flex px-2 justify-between text-white relative">
  <transition name="pop"> 
  <div @click="$emit('toggleUserInfoTab',true)"  v-if="isAsideExpanded" class="flex space-x-2 max-w-full  pop-click hover:bg-purple-500 rounded-xl p-2 w-full">
    <div class="flex-shrink-0 my-auto w-7 h-7 rounded-full  overflow-hidden"  >
      <img class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all select-none z-10" :src="costumizedUsersData.icon" alt="User Icon" @error="this.$parent.costumizedUsersData.icon = this.$parent.blankIcon" />
    </div>
    <h6 class="text-sm text-white table my-auto line-clamp-1">{{costumizedUsersData.username}}</h6>
  </div>

  <div v-else @click="$emit('toggleUserInfoTab',true)" class="w-full flex flex-col justify-center space-y-3 my-auto h-full py-3">
    <div v-click-outside="()=>toggleProfileMenu(false)"  @click="toggleProfileMenu()" class="my-auto cursor-pointer transform hover:scale-105 active:scale-100 text-xl flex justify-center">
      <ion-icon name="ellipsis-horizontal"></ion-icon>
    </div>
    <div class="flex-shrink-0 my-auto w-12 h-12 rounded-full  overflow-hidden pop-click mx-auto"  >
      <img class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all select-none z-10" :src="costumizedUsersData.icon" alt="User Icon" @error="this.$parent.costumizedUsersData.icon = this.$parent.blankIcon" />
    </div>
  </div>
  </transition>

  <transition name="slide-up"> 
  <div v-if="isAsideExpanded"  v-click-outside="()=>toggleProfileMenu(false)" @click="toggleProfileMenu()" class="w-1/12 my-auto cursor-pointer transform hover:scale-105 active:scale-100 text-xl">
    <ion-icon name="ellipsis-horizontal"></ion-icon>
  </div>
  </transition> 
   <!-- more actions tab -->
  <transition name="slide-up">
    
    <section v-if="isProfileMenuOpen" class="bg-white rounded-lg shadow-xl border border-purple-100 absolute mt-10 p-4 z-50 left-24 w-60">
      
      <div class="flex space-y-1 flex-col text-base font-bold text-gray-600">
       
        <h6 @click="$emit('toggleUserInfoTab',true)" class="hover:bg-gray-200 rounded-md py-2 px-3 active:bg-gray-100 cursor-pointer select-none overflow-hidden overflow-ellipsis whitespace-nowrap"> {{ costumizedUsersData.username }}</h6>
        <h6 @click="$emit('signOut')" class="hover:bg-gray-200 rounded-md py-2 px-3 active:bg-gray-100 cursor-pointer select-none">Sign out</h6>
      </div>
      
    </section>
  </transition>
</div>
</section>
</template>
<script>

export default {
  name : 'TopNavigation',
  data(){
    return {
      isProfileMenuOpen : false
    }
  },
  emits : ['toggleUserInfoTab','signOut'],
  props: {
    costumizedUsersData : Object,
    isAsideExpanded : Boolean
  },
  methods : {
    toggleProfileMenu(toOpen = null){
      if(toOpen !== null)return this.isProfileMenuOpen = toOpen;
      this.isProfileMenuOpen = !this.isProfileMenuOpen;
    },
    
  },
}
</script>

<style>

</style>